import { http } from '@/http'

export default {
  getDashboard(companyId) {
    const params = companyId ? { companyId } : {}
    return http.get('/dashboard', { params })
  },
  getProbationAlerts(companyId) {
    return http.get('/dashboard/alerts/probation', { params: companyId ? { companyId } : {} })
  },
  getSinrpAlerts(companyId) {
    return http.get('/dashboard/alerts/sinrp', { params: companyId ? { companyId } : {} })
  },
  getAfpWithoutEntityAlerts(companyId) {
    return http.get('/dashboard/alerts/afp-without-entity', { params: companyId ? { companyId } : {} })
  },
  getChildren18Alerts(companyId) {
    return http.get('/dashboard/alerts/children-turning-18', { params: companyId ? { companyId } : {} })
  },
  getChildren24Alerts(companyId) {
    return http.get('/dashboard/alerts/children-turning-24', { params: companyId ? { companyId } : {} })
  },
}
